import { render, staticRenderFns } from "./OverlapLayoutPhoto.vue?vue&type=template&id=d64623f0&"
import script from "./OverlapLayoutPhoto.vue?vue&type=script&lang=ts&"
export * from "./OverlapLayoutPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./OverlapLayoutPhoto.vue?vue&type=style&index=0&id=d64623f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports